export const buildGoogleMapsRouteUrl = (stops) => {
  const clean = (stops || []).map((stop) => String(stop).trim()).filter(Boolean);
  if (clean.length === 0) return null;
  if (clean.length === 1) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(clean[0])}`;
  }
  const origin = encodeURIComponent(clean[0]);
  const destination = encodeURIComponent(clean[clean.length - 1]);
  const waypoints = clean.slice(1, -1).map((stop) => encodeURIComponent(stop)).join('|');
  let url = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}&travelmode=driving`;
  if (waypoints) url += `&waypoints=${waypoints}`;
  return url;
};

export const getMapsRouteLabel = (stops, dropCount = 0) => {
  if (!stops || stops.length === 0) return null;
  if (stops.length < 2) return 'Open in Maps';
  if (dropCount > 1) return `View route (${dropCount} drops)`;
  return 'View route';
};
